"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePropagationContext = generatePropagationContext;
exports.generateSpanId = generateSpanId;
exports.generateTraceId = generateTraceId;

var _misc = require("./misc.js");

/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */
function generatePropagationContext() {
  return {
    traceId: generateTraceId(),
    spanId: generateSpanId()
  };
}
/**
 * Generate a random, valid trace ID.
 */


function generateTraceId() {
  return (0, _misc.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */


function generateSpanId() {
  return (0, _misc.uuid4)().substring(16);
}